/** Opciones para el selector. Componentes/Monitoreos */
export const ESPECTACULARES_SELECTOR = 1;
export const MEDIOS_IMPRESOS_SELECTOR = 2;
export const TIPOS_MEDIOS_IMPRESOS = 1;
export const TIPOS_DE_HALLAZGOS = 2;

export const componentsTypes = [
  {
    value: 1,
    label: 'Espectaculares'
  },
  {
    value: 2,
    label: 'Medios impresos'
  }
];

/** Opciones para el selector del tipo de catálogo de Espectaculares */
export const TIPO_HALLAZGO_SELECTOR = 1;

/** Opciones para el selector del tipo de catálogo de Medios impresos */
export const FECHAS_CAT_SELECTOR = 2;
export const MEDIDAS_CAT_SELECTOR = 3;
export const TIPOS_MI_SELECTOR = 4;

export const catalogsTypes = {
  Espectaculares: [
    {
      value: 1,
      label: 'Tipo de hallazgo'
    }
  ],
  MediosImpresos: [
    {
      value: 2,
      label: 'Fechas'
    },
    {
      value: 3,
      label: 'Medidas'
    },
    {
      value: 4,
      label: 'Tipos de Medios impresos'
    }
  ]
};
